/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SimpleAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SimpleAction({
  children,
  viewPath = "/App/Account/Content/Settings/Menu/Content/SimpleAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let authAccessTokenDataIsSupportValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(authAccessTokenDataIsSupportValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}